module.exports = __webpack_public_path__ + "static/media/market-ic.dbafee5c.png";